/**
 * LC newsletter signup tracking bridge.
 *
 * GA4 has no native newsletter event and every LC signup form posts to Klaviyo
 * client-side, so GA4 never saw a signup (AUD3-002). This bridge fires a
 * generate_lead event directly via window.gtag() — bypassing the app pixel so
 * exactly one event reaches GA4 regardless of how many pixel worker instances
 * Shopify's sandbox spins up (LOS7-862).
 *
 * The shared subscription core (assets/lc-klaviyo-subscribe.js) calls
 * window.lcTrackSignup(source) once per confirmed subscription, so each surface
 * (home newsletter, journal newsletter, popup, subscribe page, 404) reports with
 * its own stable source label. The call is deduped per source over a short
 * window as a defensive guard against any surface that fires twice.
 *
 * Loaded globally from layout/theme.liquid. Best effort: a failure here must
 * never block or break the subscribe form.
 */
(function () {
  'use strict';

  var WINDOW_MS = 5000;
  var last = {};

  window.lcTrackSignup = function (source) {
    source = source || 'unknown';
    var now = Date.now();
    if (last[source] && now - last[source] < WINDOW_MS) return;
    last[source] = now;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', { method: 'klaviyo_newsletter', source: source });
      }
    } catch (_e) {
      /* best effort — never block the form */
    }
  };
})();
